export default __webpack_public_path__ + "static/media/no-offers-img.d0b2290b.png";